var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-input-number',{attrs:{"min":_vm.valMin,"max":_vm.valMax,"disabled":_vm.disabled,"placeholder":_vm.placeholder},model:{value:(_vm.newValue),callback:function ($$v) {_vm.newValue=$$v},expression:"newValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }